module.exports = __webpack_public_path__ + "static/media/pet-background1.d88c3c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/pet-background1.png
// module id = 393
// module chunks = 0